<template>
  <div>
    <img
      src="/assets/images/shared/logo-1.png"
      alt="Application Logo"
      class="application-logo application-logo-dark"
    />
    <img
      src="/assets/images/shared/logo-2.png"
      alt="Application Logo"
      class="application-logo application-logo-light"
    />
  </div>
</template>

<style lang="scss" scoped>
.logo {
  --size: 20rem;
  width: var(--size);
  margin-bottom: 1rem;
  transform: translateX(2%);
}
</style>

<style scoped>
.application-logo {
  --size: 20rem;
  width: var(--size);
  margin-bottom: 1rem;
  transform: translateX(2%);

  display: block;
}

html.dark .application-logo-light {
  display: none;
}

html:not(.dark) .application-logo-dark {
  display: none;
}
</style>
